import React from 'react'
import { AiOutlineDashboard } from "react-icons/ai";
import { Link, useLocation } from 'react-router-dom'
import logo from '../../assets/logo.png'
import { LuBox, LuStore } from 'react-icons/lu';
import { TbCategory2, TbUsersGroup } from 'react-icons/tb';
import { RiCouponLine } from "react-icons/ri";
import { MdOutlineExplore } from "react-icons/md";
import { IoSettingsOutline } from 'react-icons/io5';
import { FiUsers } from 'react-icons/fi';
import { FaMapLocationDot } from "react-icons/fa6";



function Sidebar() {

    const location = useLocation();

    const menu = [
        {
            title: "Dashboard",
            path: "/",
            icon: <AiOutlineDashboard size={22} />
        },
        {
            title: "Products",
            path: "/products",
            icon: <LuBox size={22} />
        },
        {
            title: "Category",
            path: "/category",
            icon: <TbCategory2 size={22} />
        },
        {
            title: "Coupons",
            path: "/coupons",
            icon: <RiCouponLine size={22} />
        },
        {
            title: "Orders",
            path: "/orders",
            icon: <MdOutlineExplore size={22} />
        },

        {
            title: "Customers",
            path: "/customers",
            icon: <FiUsers size={22} />
        },
        {
            title: "Staffs",
            path: "/staffs",
            icon: <TbUsersGroup size={22} />
        },
        {
            title: "Shops",
            path: "/our-shop",
            icon: <FaMapLocationDot size={22} />
        }
        ,
        {
            title: "Settings",
            path: "/settings",
            icon: <IoSettingsOutline size={22} />
        },
        {
            title: "Store Customization",
            path: "/store/customisation",
            icon: <LuStore size={22} />
        }

    ]

    return (
        <div className='py-10 px-5 bg-white h-full overflow-y-auto'>
            {/* Logo  */}
            <div className="w-full flex">
                <img src={logo} className='w-32' alt="" />
            </div>

            {/* Navigation  */}
            <div className="w-full mt-10 overflow-y-auto">
                <ul className="">
                    {menu.map((li, i) => (
                        <li
                            key={i}
                            className={`p-4 py-3 text-sm ${location.pathname === li.path ?
                                'bg-[#7565db] text-white' : null} 
                            flex items-center gap-2.5 rounded-xl font-medium text-gray-500
                            `}
                        >
                            {li.icon}
                            <Link
                                to={li.path}
                            >
                                {li.title}
                            </Link>
                        </li>
                    ))}
                    {/* 
                    <li className="py-3 px-4 text-sm flex items-center gap-2.5 rounded-xl font-medium text-gray-500">
                        <LuStore size={22} />
                        <Link>Onli</Link>
                    </li> */}
                </ul>
            </div>
        </div>
    )
}

export default Sidebar